var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"horizontal layout center match-answer animate__animated animate__fadeIn px-1",class:{'white': !_vm.isTextColourLight}},[_c('span',{staticClass:"match-answer-item horizontal layout center",class:{
      'm-2': _vm.size === 'lg',
      'm-1.5': _vm.size === 'md',
      'm-1': _vm.size === 'sm',
      'm-0.5': _vm.size === 'xs',
    }},[_c('AhaSvg',{staticClass:"aha-option__icon icon-correct mr-0.5",attrs:{"name":"correct","view-box":"0 0 18 18","maintain-color":"","width":_vm.correctIconWidth,"height":_vm.correctIconHeight}}),_c('div',{staticClass:"ml-0.5",class:{
        'font-24': _vm.size === 'lg',
        'font-22': _vm.size === 'md',
        'font-18': _vm.size === 'sm',
        'font-14': _vm.size === 'xs',
      }},[_c('span',[_vm._v(_vm._s(_vm._f("formatNumber")(_vm.numberOfCorrectAnswers)))]),(_vm.isShowUserIcon)?_c('i',{staticClass:"fas fa-user fa-sm fa-fw mb-0.5",attrs:{"aria-hidden":"true"}}):_vm._e()])],1),_c('span',{staticClass:"line mx-0.5"},[_vm._v("|")]),_c('span',{staticClass:"match-answer-item horizontal layout center",class:{
      'm-2': _vm.size === 'lg',
      'm-1.5': _vm.size === 'md',
      'm-1': _vm.size === 'sm',
      'm-0.5': _vm.size === 'xs',
    }},[_c('AhaSvg',{staticClass:"aha-option__icon icon-incorrect mr-0.5",attrs:{"name":"incorrect","view-box":"0 0 18 18","maintain-color":"","width":_vm.incorrectIconWidth,"height":_vm.incorrectIconHeight}}),_c('div',{staticClass:"ml-0.5",class:{
        'font-24': _vm.size === 'lg',
        'font-22': _vm.size === 'md',
        'font-18': _vm.size === 'sm',
        'font-14': _vm.size === 'xs',
      }},[_c('span',[_vm._v(_vm._s(_vm._f("formatNumber")(_vm.numberOfIncorrectAnswers)))]),(_vm.isShowUserIcon)?_c('i',{staticClass:"fas fa-user fa-sm fa-fw mb-0.5",attrs:{"aria-hidden":"true"}}):_vm._e()])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }